import { Component } from '@theme/component';

/**
 * Quick add component for product cards.
 * Handles prefetching product pages and adding to cart.
 */
export class QuickAddComponent extends Component {
  #prefetchedUrl = null;
  #prefetchPromise = null;

  /**
   * Prefetches a product page for quick add.
   * @param {string} url - The product page URL to prefetch.
   */
  fetchProductPage(url) {
    if (this.#prefetchedUrl === url) return;
    this.#prefetchedUrl = url;
    
    const sectionId = 'quick-add-modal-content';
    const fetchUrl = url + (url.includes('?') ? '&' : '?') + 'section_id=' + sectionId;
    
    this.#prefetchPromise = fetch(fetchUrl)
      .then(response => response.text())
      .catch(() => null);
  }

  /**
   * Shows the quick add dialog with the product content.
   * @param {string} url - The product URL.
   */
  async showDialog(url) {
    const dialog = document.querySelector('#quick-add-dialog');
    if (!dialog) return;
    
    if (this.#prefetchedUrl !== url) {
      this.fetchProductPage(url);
    }
    
    const html = await this.#prefetchPromise;
    if (!html) return;
    
    const content = dialog.querySelector('#quick-add-modal-content, [ref="content"]');
    if (content) {
      content.innerHTML = html;
    }
    
    const dialogEl = dialog.querySelector('dialog');
    if (dialogEl) {
      dialogEl.showModal();
    }
  }
}

if (!customElements.get('quick-add-component')) {
  customElements.define('quick-add-component', QuickAddComponent);
}
